// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"5241c41a","393":"6c92f6a1"}[chunkId] + ".chunk.js";
};